import React, { useId } from 'react'
import './checkbox.scss'

interface IProps {
  isActive: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  title: string
}

export const CheckboxV2 = ({isActive, onClick, title }: IProps): React.ReactElement => {
  const id = useId()

  return (
    <div className='checkbox-v2' onClick={onClick}>
      <input type='checkbox' id={id} checked={isActive} readOnly />
      <label htmlFor={id} onClick={onClick}>
        {title}
      </label>
    </div>
  )
}
